export default function CompanySection() {
  return (
    <section
      id="company"
      className="relative min-h-screen flex flex-col justify-center overflow-hidden"
      style={{ fontFamily: "'Inter', sans-serif" }}
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/44c983ee54a9b99c192d36feb8566181.jpg"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/80" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10 pt-28 pb-20 w-full">
        {/* Badge */}
        <div className="flex justify-center mb-8">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-white/20 bg-white/10 text-white/80 text-xs font-medium tracking-widest uppercase backdrop-blur-sm">
            <i className="ri-apple-line text-sm" />
            iOS Platform Specialists
          </span>
        </div>

        {/* Headline */}
        <h1 className="text-center text-white font-bold leading-tight mb-6">
          <span className="block text-5xl md:text-7xl lg:text-8xl tracking-tight">
            FELIN SRL
          </span>
          <span className="block text-2xl md:text-3xl lg:text-4xl font-light text-white/70 mt-3 tracking-wide">
            Engineering the Future of iOS
          </span>
        </h1>

        {/* Description */}
        <p className="text-center text-white/60 text-base md:text-lg max-w-2xl mx-auto leading-relaxed mb-14">
          A team of experts crafting modern, high-performance applications for the iOS platform —
          designed to enhance user experience and elevate the security of mobile devices worldwide.
        </p>

        {/* Floating cards */}
        <div className="flex justify-center gap-4 md:gap-6 flex-wrap">
          {[
            {
              icon: "ri-shield-check-line",
              label: "VPN Protection",
              desc: "Military-grade encryption",
              color: "from-emerald-900/60 to-emerald-800/40",
              accent: "text-emerald-400",
            },
            {
              icon: "ri-delete-bin-2-line",
              label: "Smart Cleaner",
              desc: "Deep device optimization",
              color: "from-rose-900/60 to-rose-800/40",
              accent: "text-rose-400",
            },
            {
              icon: "ri-lock-password-line",
              label: "Privacy First",
              desc: "Zero data collection",
              color: "from-amber-900/60 to-amber-800/40",
              accent: "text-amber-400",
            },
          ].map((card) => (
            <div
              key={card.label}
              className={`bg-gradient-to-br ${card.color} border border-white/10 backdrop-blur-md rounded-2xl p-5 w-44 md:w-52 flex flex-col gap-2`}
            >
              <div className={`w-8 h-8 flex items-center justify-center ${card.accent}`}>
                <i className={`${card.icon} text-xl`} />
              </div>
              <p className="text-white font-semibold text-sm">{card.label}</p>
              <p className="text-white/50 text-xs">{card.desc}</p>
            </div>
          ))}
        </div>


      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 text-white/40 animate-bounce">
        <i className="ri-arrow-down-line text-2xl" />
      </div>
    </section>
  );
}
